// extracted by mini-css-extract-plugin
export default {"root":"SectionFooter__root","footerValue":"SectionFooter__footerValue","footerName":"SectionFooter__footerName","isGroup":"SectionFooter__isGroup"};